module.exports = __webpack_public_path__ + "img/37.574e22e0.jpg";